import { render, staticRenderFns } from "./WhModal.vue?vue&type=template&id=458b9b1e&"
import script from "./WhModal.vue?vue&type=script&lang=js&"
export * from "./WhModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports